import { Loading } from 'element-ui'
let Loadings = null
let timer = null
let times = 0
export  const  starLoading = function (TargetLoadingDom = '.app-main-loading') {
  times ++
  if(!Loadings){
    TargetLoadingDom =  document.querySelector(TargetLoadingDom)
    // console.error('startLoading',times)
    Loadings = Loading.service({
      target: TargetLoadingDom,
      lock: true,
      text: '加载中……',
      // spinner:'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    // hanck 一分钟之后确保loading消失
    timer = setTimeout(()=>{
      closeLoading()
    },6000)
  }
  return Loadings
}
export  const  closeLoading = function () {
  // console.error(times)
  times --
  if(times <=0){
    times = 0
    if(Loadings && Loadings.close) {
      // console.error('end 222')
      clearTimeout(timer)
      Loadings.close()
      Loadings = null
     }
  }
  return Loadings
}
// request 之外使用的方法
export  const  starOutRequestLoading = function (TargetLoadingDom = '.app-main') {
  // setTimeout(()=>{
    closeOutRequestLoading() // 先关掉再打开
    times  = 999
     starLoading(TargetLoadingDom)
  // },100)
  return Loadings
}
// 强行关闭loading
export  const  closeOutRequestLoading = function () {
   times = 0
  return  closeLoading()
}
export  const  getCurrentLoading = function () {

  return Loadings
}
export default {
  starLoading,
  closeLoading,
  starOutRequestLoading,
  closeOutRequestLoading,
  getCurrentLoading,
  Loadings
}



// WEBPACK FOOTER //
// ./src/utils/loading.js